import { StoredHeadersService } from '@core/abstractions';
import { LocalStorageService } from '@shared/services';

export class SalesOrderStoredHeadersService extends StoredHeadersService {
	constructor(_localStorageService: LocalStorageService) {
		super('SalesOrderHeaderBinding', _localStorageService);
	}
}
